import { TransactionEntryFilter } from '../../graphql/generated';
import { DateRange } from '../../types';
import { dt, isAllTimeDateRange } from '../../util/dateTime';
import { HISTORICAL_MONTHS, UNKNOWN_MERCHANT_ID } from './constants';

export const buildTransactionEntriesFilter = ({
    categoryIds,
    accountIds,
    merchantId,
    dateRange,
    tagNames,
}: {
    categoryIds: string[] | null;
    accountIds: string[] | null;
    tagNames: string[] | null;
    merchantId: string | null;
    dateRange: DateRange;
}) => {
    const filter: TransactionEntryFilter = {};

    if (isAllTimeDateRange(dateRange)) {
        // Since fetching all transactions is expensive, we apply filters to run on the server
        if (categoryIds) filter.categoryId = { in: categoryIds };
        if (accountIds) filter.financialEntityId = { in: accountIds };
        if (merchantId) {
            filter.merchantId =
                merchantId === UNKNOWN_MERCHANT_ID
                    ? { isNull: true }
                    : { equalTo: merchantId };
        }
        // TODO: May need to make some tweaks here for performance
        if (tagNames)
            filter.transactionEntriesTransactionEntryTags = {
                some: {
                    transactionEntryTag: { name: { in: tagNames } },
                },
            };
    } else {
        filter.date = {
            // Fetch 3 months of historical data to calculate 3-month averages
            greaterThanOrEqualTo: dt(dateRange.startDate)
                .subtract(HISTORICAL_MONTHS, 'months')
                .toDateStr(),
            lessThanOrEqualTo: dateRange.endDate,
        };
    }

    return filter;
};
